var map = {
	"./development.json": "+5V6",
	"./local.json": "mH2u",
	"./production.json": "gZi+",
	"./staging.json": "z+/s"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3MJM";


//////////////////
// WEBPACK FOOTER
// ./config ^\.\/.*\.json$
// module id = 3MJM
// module chunks = 1